/* Gravure-voorbeeld: tekst of logo ingebrand op een foto van de plank (alles lokaal in de browser). */
(function () {
  var FONTS = {
    serif: '500 {s}px "Playfair Display", Georgia, serif',
    sans: '600 {s}px "DM Sans", Arial, sans-serif',
    hand: '600 {s}px Caveat, cursive'
  };
  var t = function (k, v) {
    var s = (window.T && window.T[k]) || '';
    if (v) { for (var x in v) { s = s.split('{' + x + '}').join(v[x]); } }
    return s;
  };
  var FONT_NAMES = { serif: 'font_serif', sans: 'font_sans', hand: 'font_hand' };
  var LINE = 1.15;

  document.querySelectorAll('[data-engrave]').forEach(function (root) {
    var section = root.closest('section');
    var boards;
    try { boards = JSON.parse(section.querySelector('[data-engrave-boards]').textContent); } catch (e) { return; }
    boards = boards.filter(function (b) { return b.src; });
    if (!boards.length) return;

    var canvas = root.querySelector('[data-engrave-canvas]');
    var ctx = canvas.getContext('2d');
    var textEl = root.querySelector('[data-engrave-text]');
    var textSizeEl = root.querySelector('[data-engrave-textsize]');
    var logoSizeEl = root.querySelector('[data-engrave-logosize]');
    var fileEl = root.querySelector('[data-engrave-file]');
    var invertEl = root.querySelector('[data-engrave-invert]');
    var loading = root.querySelector('[data-engrave-loading]');
    var state = { board: 0, font: 'serif', logo: null, logoName: '', pos: 'corner' };
    var imgs = {};
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var pending = null;

    function schedule() {
      if (pending) return;
      pending = requestAnimationFrame(function () { pending = null; draw(); });
    }

    function loadBoard(i) {
      if (imgs[i]) return;
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { if (loading) loading.hidden = true; schedule(); };
      im.src = boards[i].src;
      imgs[i] = im;
    }

    function currentLines() {
      var t = textEl.value.trim();
      // Voorbeeldtekst uit de editor: | is een nieuwe regel.
      if (!t && !state.logo) t = (root.getAttribute('data-default-text') || '').replace(/\s*\|\s*/g, '\n');
      return t.split(/\n/).map(function (l) { return l.trim(); }).filter(Boolean).slice(0, 3);
    }

    // Logo omzetten naar een 'brandmerk': donker wordt inkt, licht (of transparant) valt weg.
    function silhouette(img, w, h, invert) {
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h));
      var x = c.getContext('2d');
      x.drawImage(img, 0, 0, c.width, c.height);
      var d;
      try { d = x.getImageData(0, 0, c.width, c.height); } catch (e) { return c; }
      var p = d.data;
      for (var i = 0; i < p.length; i += 4) {
        var lum = (0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]) / 255;
        var ink = invert ? lum : 1 - lum;
        ink = Math.min(1, Math.max(0, (ink - 0.18) / 0.62)) * (p[i + 3] / 255);
        p[i] = p[i + 1] = p[i + 2] = 0;
        p[i + 3] = Math.round(ink * 255);
      }
      x.putImageData(d, 0, 0);
      return c;
    }

    function fontSize(g, lines, maxW, maxH) {
      g.font = FONTS[state.font].replace('{s}', 200);
      var widest = Math.max.apply(null, lines.map(function (l) { return g.measureText(l).width; })) || 1;
      return Math.max(8, Math.min(200 * maxW / widest, maxH / (lines.length * LINE)));
    }

    function drawLines(g, lines, fs, cx, top) {
      g.font = FONTS[state.font].replace('{s}', fs);
      g.textAlign = 'center'; g.textBaseline = 'top'; g.fillStyle = '#000';
      lines.forEach(function (l, i) { g.fillText(l, cx, top + i * fs * LINE); });
    }

    function tint(layer, color) {
      var c = document.createElement('canvas');
      c.width = layer.width; c.height = layer.height;
      var x = c.getContext('2d');
      x.drawImage(layer, 0, 0);
      x.globalCompositeOperation = 'source-in';
      x.fillStyle = color; x.fillRect(0, 0, c.width, c.height);
      return c;
    }

    // Branden: een zachte, bruine schroeirand en een donkere kern, vermenigvuldigd met het hout (nerf blijft zichtbaar).
    function burn(layer, W) {
      var halo = tint(layer, 'rgb(122,72,36)'), core = tint(layer, 'rgb(50,27,12)');
      ctx.save();
      ctx.globalCompositeOperation = 'multiply';
      ctx.globalAlpha = 0.55; ctx.shadowColor = 'rgba(110,60,25,.6)'; ctx.shadowBlur = Math.max(2, W * 0.006);
      ctx.drawImage(halo, 0, 0);
      ctx.shadowBlur = 0; ctx.shadowColor = 'transparent';
      ctx.globalAlpha = 0.9;
      ctx.drawImage(core, 0, 0);
      ctx.restore();
    }

    function draw() {
      var b = boards[state.board], img = imgs[state.board];
      if (!img || !img.naturalWidth) return;
      var cr = b.crop;
      var sx = img.naturalWidth * cr[3] / 100, sy = img.naturalHeight * cr[0] / 100;
      var sw = img.naturalWidth * (1 - (cr[1] + cr[3]) / 100), sh = img.naturalHeight * (1 - (cr[0] + cr[2]) / 100);
      var cssW = canvas.parentNode.clientWidth || 600;
      var W = Math.round(cssW * dpr), H = Math.round(W * sh / sw);
      canvas.width = W; canvas.height = H;
      canvas.style.aspectRatio = sw + ' / ' + sh;
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, W, H);

      var layer = document.createElement('canvas');
      layer.width = W; layer.height = H;
      var g = layer.getContext('2d');
      // Graveervlak: linksonder (plek van ons brandmerk) of in het midden.
      var z = state.pos === 'center' ? b.center : b.zone;
      var zx = W * z[0] / 100, zy = H * z[1] / 100, zw = W * z[2] / 100, zh = H * z[3] / 100;
      var tScale = parseInt(textSizeEl.value, 10) / 100, lScale = parseInt(logoSizeEl.value, 10) / 100;
      var lines = currentLines();

      var dw = 0, dh = 0, fs = 0, tw = 0, th = 0;
      if (state.logo) {
        var lw = state.logo.naturalWidth || state.logo.width || 400, lh = state.logo.naturalHeight || state.logo.height || 200;
        var boxH = lines.length ? zh * 0.6 : zh;
        var sc = Math.min(zw / lw, boxH / lh) * lScale;
        dw = lw * sc; dh = lh * sc;
      }
      if (lines.length) {
        fs = fontSize(g, lines, state.logo ? zw * 0.9 : zw, state.logo ? zh * 0.4 : zh) * tScale;
        g.font = FONTS[state.font].replace('{s}', fs);
        tw = Math.max.apply(null, lines.map(function (l) { return g.measureText(l).width; }));
        th = lines.length * fs * LINE;
      }
      var gap = (dh && th) ? Math.max(zh * 0.08, fs * 0.25) : 0;
      var cw = Math.max(dw, tw), ch = dh + gap + th;
      var left, top;
      if (state.pos === 'center') { left = zx - cw / 2; top = zy - ch / 2; }
      else { left = zx - zw / 2; top = zy + zh / 2 - ch; }   // groeit vanaf de hoek naar rechts en omhoog
      left = Math.max(W * 0.02, Math.min(left, W * 0.98 - cw));
      top = Math.max(H * 0.02, Math.min(top, H * 0.98 - ch));
      if (dw) g.drawImage(silhouette(state.logo, dw, dh, invertEl && invertEl.checked), left + (cw - dw) / 2, top);
      if (th) drawLines(g, lines, fs, left + cw / 2, top + dh + gap + fs * 0.06);
      burn(layer, W);
      canvas.setAttribute('aria-label', 'Voorbeeld: ' + (lines.join(' ') || 'logo') + (state.logo && lines.length ? ' met logo' : '') + ' ingebrand op de ' + b.name.toLowerCase());
    }

    // Pas laden als het blok in de buurt komt: geen extra foto's bij het openen van de pagina.
    function start() {
      loadBoard(state.board);
      if (document.fonts && document.fonts.load) {
        Promise.all(Object.keys(FONTS).map(function (k) { return document.fonts.load(FONTS[k].replace('{s}', 40)); })).then(schedule, schedule);
      }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); start(); }
      }, { rootMargin: '400px 0px' });
      io.observe(root);
    } else { start(); }
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(canvas.parentNode);

    textEl.addEventListener('input', schedule);
    function sliderLabel(el, sel) { var v = root.querySelector(sel); if (v) v.textContent = el.value + '%'; }
    textSizeEl.addEventListener('input', function () { sliderLabel(textSizeEl, '[data-engrave-textsize-value]'); schedule(); });
    logoSizeEl.addEventListener('input', function () { sliderLabel(logoSizeEl, '[data-engrave-logosize-value]'); schedule(); });
    if (invertEl) invertEl.addEventListener('change', schedule);

    root.addEventListener('click', function (e) {
      var f = e.target.closest('[data-engrave-font]');
      if (f) {
        state.font = f.getAttribute('data-engrave-font');
        root.querySelectorAll('[data-engrave-font]').forEach(function (x) { x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
        schedule(); return;
      }
      var pp = e.target.closest('[data-engrave-pos]');
      if (pp) {
        state.pos = pp.getAttribute('data-engrave-pos');
        root.querySelectorAll('[data-engrave-pos]').forEach(function (x) { x.setAttribute('aria-pressed', x === pp ? 'true' : 'false'); });
        schedule(); return;
      }
      var bb = e.target.closest('[data-engrave-board]');
      if (bb) {
        state.board = parseInt(bb.getAttribute('data-engrave-board'), 10);
        root.querySelectorAll('[data-engrave-board]').forEach(function (x) { x.setAttribute('aria-pressed', x === bb ? 'true' : 'false'); });
        loadBoard(state.board); schedule(); return;
      }
      if (e.target.closest('[data-engrave-remove]')) {
        state.logo = null; state.logoName = ''; fileEl.value = '';
        root.querySelector('[data-engrave-file-label]').textContent = 'Logo kiezen';
        root.querySelector('[data-engrave-remove]').hidden = true;
        root.querySelector('[data-engrave-logo-opts]').hidden = true;
        root.querySelector('[data-engrave-logosize-wrap]').hidden = true;
        schedule(); return;
      }
      if (e.target.closest('[data-engrave-cta]')) {
        var body = document.querySelector('#offerte textarea[name="contact[body]"]');
        if (body) {
          var lines = currentLines();
          var note = t('engrave_note', {
            tekst: lines.length ? '"' + lines.join(' / ') + '"' : t('engrave_logo_only'),
            lettertype: t(FONT_NAMES[state.font]),
            plank: boards[state.board].name.toLowerCase(),
            plek: state.pos === 'center' ? t('engrave_pos_center') : t('engrave_pos_bottom_left'),
            logo: state.logo ? t('engrave_mail', { naam: state.logoName }) : ''
          });
          var marker = note.split(':')[0] + ':';
          if (body.value.indexOf(marker) === -1) body.value = note + (body.value ? '\n' + body.value : '');
        }
      }
    });

    fileEl.addEventListener('change', function () {
      var file = fileEl.files && fileEl.files[0];
      if (!file) return;
      if (file.size > 10 * 1024 * 1024) { window.alert(t('logo_too_big')); fileEl.value = ''; return; }
      var reader = new FileReader();
      reader.onload = function () {
        var im = new Image();
        im.onload = function () {
          state.logo = im; state.logoName = file.name;
          root.querySelector('[data-engrave-file-label]').textContent = 'Ander logo';
          root.querySelector('[data-engrave-remove]').hidden = false;
          root.querySelector('[data-engrave-logo-opts]').hidden = false;
          root.querySelector('[data-engrave-logosize-wrap]').hidden = false;
          schedule();
        };
        im.onerror = function () { window.alert(t('logo_unreadable')); };
        im.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  });
})();
